import React, {useState} from "react";
import "./footer.scss";
import logo from "../../../Media/bsd-white.png";
import {Link} from "react-router-dom";
import {HashLink} from "react-router-hash-link";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faArrowCircleUp} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  const [isOpen] = useState(false);
  return (
    <div className="container-footer">
      <div className="footer">
        <div className="container-atas">
          <div className="container-logo">
            <img className="gambar-logo" src={logo} alt="logo-Parkspring" />
          </div>
          <div className={isOpen ? "menus active" : "menus"}>
            {" "}
            Website Map
            <ul>
              <li>
                <HashLink className="link" smooth to="/">
                  Home
                </HashLink>
              </li>
              <li>
                <HashLink className="link" smooth to="/#promo">
                  Promo
                </HashLink>
              </li>
              <li>
                <HashLink className="link" smooth to="/#residentials">
                  Residentials
                </HashLink>
              </li>
              <li>
                <HashLink className="link" smooth to="/Commercial">
                  Ruko Commercials
                </HashLink>
              </li>

              <li>
                <HashLink className="link" smooth to="/#lokasi">
                  Location
                </HashLink>
              </li>
            </ul>
          </div>
          <div className="container-deskripsi">
            <div className="alamat">
              <h1>Marketing Gallery</h1>
              <h2>BSD City</h2>
              <h3>Dapatkan Informasi Promo, Brosur dan Pricelist Terbaru</h3>
              <h4>Contact us : +6282122005507 (Dean)</h4>
              <Link to="/privacy-policy" color="white">
                <div className="footer-contact">Privacy Policy</div>
              </Link>
            </div>
            <div className="privasi"></div>
          </div>
        </div>
        <hr color="white" />
        <div className="container-bawah">
          <div className="rights">All rights reserved</div>
          <div className="judulcontainerbawah">
            <div className="copyright">© BSD City</div>
            <div className="powered">Powered by Linktown</div>
          </div>
          <div className="backtotop">
            <ul>
              <li>
                <HashLink className="link" smooth to="#navbar">
                  Back to Top
                </HashLink>
              </li>
            </ul>
            <FontAwesomeIcon icon={faArrowCircleUp} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
